import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import TimeslotPopover from "../timeslot-popover/timeslot-popover";
import util from "../util/util";

export default function ScheduleByDaySchedule(props) {
  return (
    <div>
      <ul className="nav nav-tabs">
        <li role="presentation" className="active">
          <a href="#tab1" data-toggle="tab">
            00:00 - 7:30
          </a>
        </li>
        <li role="presentation">
          <a href="#tab2" data-toggle="tab">
            08:00 - 15:30
          </a>
        </li>
        <li role="presentation">
          <a href="#tab3" data-toggle="tab">
            16:00 - 23:30
          </a>
        </li>
      </ul>

      <div className="tab-content">
        <div className="tab-pane active" id="tab1">
          {renderScheduleByIndex(0, 32)}
        </div>
        <div className="tab-pane" id="tab2">
          {renderScheduleByIndex(32, 64)}
        </div>
        <div className="tab-pane" id="tab3">
          {renderScheduleByIndex(64, 96)}
        </div>
      </div>
    </div>
  );

  // render a TABLE of some of the schedule data;
  function renderScheduleByIndex(startIndex, endIndex) {
    const schedule = props.schedule.slice(startIndex, endIndex);

    return (
      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover">
          <colgroup>
            <col style={{ width: `15%` }}></col>
            <col style={{ width: `85%` }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>Time Slot</th>
              <th>Pod</th>
            </tr>
          </thead>
          <tbody>
            {schedule.map((row, index) => (
              <tr key={index}>
                {row.timeslot.substr(-1) !== `0` ? (
                  <th>
                    <Link
                      to={util.returnScheduleTimeSlotUrl(
                        row.timeslot,
                        props.day
                      )}
                    >
                      {row.timeslot}
                    </Link>
                  </th>
                ) : (
                  <th>{row.timeslot}</th>
                )}
                {typeof row.show !== `string` ? (
                  <td>
                    {row.show && row.show.pod ? (
                      <TimeslotPopover
                        pod={row.show.pod}
                        rule={row.show.rule}
                      />
                    ) : null}
                  </td>
                ) : (
                  <td>{row.show}</td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

ScheduleByDaySchedule.propTypes = {
  day: PropTypes.string, // used to generate links to a timeslot view;
  schedule: PropTypes.array // daily schedule data to display (one array to be broken into three tabs);
};
